export const BARCODE_TYPES = {
  EAN: 'ean',
  UPC: 'upc',
};
